function AppLayoutViewService($state, hUser, brandServices, TeamScheduleService) {
        const self = this;
        const _emitter = JarEventEmitter.call(self);

        self.isFullScreen = false;

        self.EVENTS = {
            TOGGLE_SIDE_BAR: 'toggle_side_bar',
            THEME_UPDATE: 'theme_update',
            SIDE_BAR_STATE_CHANGE: 'side_bar_state_change',
        };

        self.SIDE_BAR_STATE = {
            OPEN: 'OPEN',
            CLOSED: 'CLOSED',
        };

        self.TOGGLE_SOURCE = {
            HEADER: 'HEADER',
            SIDE_BAR: 'SIDE_BAR',
            USER_CLICK: 'USER_CLICK',
        };

        var cache = {};
        var CACHE_KEYS = {
            BRAND_BASIC_MEDIA: 'BRAND_BASIC_MEDIA',
            BRAND_BASIC_INFO: 'BRAND_BASIC_INFO',
        };

        var sideBarState = self.SIDE_BAR_STATE.CLOSED;
        var toggleSource;
        var brandTheme;

        self.toggleSideBar = function (source) {
            _emitter.trigger(self.EVENTS.TOGGLE_SIDE_BAR, source);
        };

        self.setFullScreenMode = (enabled) => {
            self.isFullScreen = !!enabled;

            if (self.isFullScreen) {
                $('body').addClass('full-screen');
            } else {
                $('body').removeClass('full-screen');
            }
        }

        self.triggerSideBarStateChange = () => {
            _emitter.trigger(self.EVENTS.SIDE_BAR_STATE_CHANGE);
        };

        self.checkIfHasNavBarMenu = function () {
            return ($state.current.name.includes('appLayout.harriSH.pms') ||
                $state.current.name.includes('appLayout.harriSH.communication-hub') ||
                $state.current.name.includes('appLayout.harriSH.adam.address-confirm') ||
                $state.current.name.includes('appLayout.harriSH.adam.compliance-review'));
        };

        self.setSideBarState = (isSideBarExpanded) => {
            sideBarState = isSideBarExpanded ? self.SIDE_BAR_STATE.OPEN : self.SIDE_BAR_STATE.CLOSED;

            if (isSideBarExpanded && self.getToggleSource() !== self.TOGGLE_SOURCE.HEADER) {
                $('body').addClass('side-bar-expanded');
            } else {
                $('body').removeClass('side-bar-expanded');
            }
        };

    const getRouteConfigValue = (key) => {
        const currentState = $state.current.name;
        const stateParts = currentState.split('.');
        let value;

        while (stateParts.length) {
            const state = $state.get(stateParts.join('.'));

            if (state.hasOwnProperty(key)) {
                value = state[key];
                return value;
            }

            stateParts.pop();
        }

        return value;
    };

        self.getSideBarState = function () {
            return sideBarState;
        };

        self.isSideBarExpanded = function () {
            return sideBarState === self.SIDE_BAR_STATE.OPEN;
        };

        self.setToggleSource = function (source) {
            toggleSource = source;
        };

        self.getToggleSource = function () {
            return toggleSource;
        };

        var setBrandTheme = function (settings, elem) {
            brandTheme = settings;
            let primaryRGB = [0, 136, 221].join(',');
            let headerRGB = [255, 255, 255].join(',');
            let accentColor = `0088dd`;

            if (settings && settings.scheme_settings) {
                accentColor = settings.scheme_settings.accent_color ? ColorUtils.normalizeHex(settings.scheme_settings.accent_color) : '0088dd';
                const backgroundColor = settings.scheme_settings.background_color ? ColorUtils.normalizeHex(settings.scheme_settings.background_color) : 'ffffff';
                var primaryColor = Utils.hexToRGB(accentColor);
                var headerColor = Utils.hexToRGB(backgroundColor);

                if (primaryColor) {
                    primaryRGB = [
                        primaryColor.r,
                        primaryColor.g,
                        primaryColor.b
                    ].join(',');
                }

                if (headerColor) {
                    headerRGB = [
                        headerColor.r,
                        headerColor.g,
                        headerColor.b
                    ].join(',');
                }
            }

            elem.style.setProperty('--harri_primary_rgb', primaryRGB);
            elem.style.setProperty('--harri_header_rgb', headerRGB);
            elem.style.setProperty('--harri_primary', 'rgb(' + primaryRGB + ')');
            elem.style.setProperty('--harri_header', 'rgb(' + headerRGB + ')');

            elem.style.setProperty('--h-accent-rgb', primaryRGB);
            elem.style.setProperty('--h-accent', `#${accentColor}`);
            elem.style.setProperty('--h-accent-100', `color-mix(in oklab, var(--h-accent) 20%, white)`);
            elem.style.setProperty('--h-accent-400', `color-mix(in oklab, var(--h-accent) 80%, white)`);
            elem.style.setProperty('--h-accent-600', `color-mix(in oklab, var(--h-accent) 80%, black)`);

            _emitter.trigger(self.EVENTS.THEME_UPDATE, settings);
        };

        self.getBrandTheme = function () {
            return brandTheme;
        };

        self.updateBrandTheme = function (theme, cacheName, elem) {
            cacheName = cacheName || 'brand_theme';
            elem = elem || document.documentElement;
            var defer = $q.defer();
            setBrandTheme(HStorageManager.get({key: cacheName, storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE}), elem);

            if (hUser.data.user.user_employer && !theme) {
                var brandIds = _.pluck(hUser.data.user.brands_list, 'id');

                if (brandIds.length !== 1) {
                    brandIds.push(hUser.getUserContext().brand_id);
                }

                brandServices.check(brandServices.SERVICES.MICE, brandIds[0])
                    .then(function (isMiceEnabled) {
                        if (isMiceEnabled) {
                            MiceAPI.getEmployerMediaBranding()
                                .then(function (settings) {
                                    HStorageManager.put({
                                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                        key: cacheName,
                                        value: settings
                                    });
                                    setBrandTheme(settings, elem);
                                });
                        } else {
                            HStorageManager.remove({
                                key: cacheName,
                                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                            })
                            setBrandTheme(null, elem);
                        }

                        defer.resolve();
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            } else {
                if (theme) {
                    HStorageManager.put({
                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                        key: cacheName,
                        value: theme
                    });
                    setBrandTheme(theme, elem);
                } else {
                    HStorageManager.remove({
                        key: cacheName,
                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                    })
                    setBrandTheme(null, elem);
                }
                defer.resolve();
            }

            return defer.promise;
        };

        self.getBrandBasicMedia = function (brandId) {
            var defer = $q.defer();

            if (cache[CACHE_KEYS.BRAND_BASIC_MEDIA] && cache[CACHE_KEYS.BRAND_BASIC_MEDIA][brandId]) {
                defer.resolve(cache[CACHE_KEYS.BRAND_BASIC_MEDIA][brandId]);
            } else {
                BrandAPI.getBrandBasicMedia(brandId)
                    .then(function (brandBasicMedia) {
                        cache[CACHE_KEYS.BRAND_BASIC_MEDIA] = cache[CACHE_KEYS.BRAND_BASIC_MEDIA] || {};
                        cache[CACHE_KEYS.BRAND_BASIC_MEDIA][brandId] = brandBasicMedia;
                        defer.resolve(cache[CACHE_KEYS.BRAND_BASIC_MEDIA][brandId]);
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        self.getBrandBasicInfo = function (brandId) {
            var defer = $q.defer();

            if (cache[CACHE_KEYS.BRAND_BASIC_INFO] && cache[CACHE_KEYS.BRAND_BASIC_INFO][brandId]) {
                defer.resolve(cache[CACHE_KEYS.BRAND_BASIC_INFO][brandId]);
            } else {
                BrandAPI.getBrandBasicInfo(brandId)
                    .then(function (brandBasicInfo) {
                        cache[CACHE_KEYS.BRAND_BASIC_INFO] = cache[CACHE_KEYS.BRAND_BASIC_INFO] || {};
                        cache[CACHE_KEYS.BRAND_BASIC_INFO][brandId] = brandBasicInfo;
                        defer.resolve(cache[CACHE_KEYS.BRAND_BASIC_INFO][brandId]);
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }

            return defer.promise;
        };

        self.handleBrandChange = (brand) => {
            const defer = $q.defer();

            brandServices.check(brandServices.SERVICES.TEAM_SCHEDULING, brand.id)
                .then((isTeamSchedulingEnabled) => {
                    if (isTeamSchedulingEnabled) {
                        TeamScheduleService.getBrands()
                            .then(() => {
                                TeamScheduleService.setActiveBrand(brand);
                                defer.resolve();
                            })
                            .catch((err) => console.error(err));
                    }

                    if (!getRouteConfigValue('stopBrandSwitchRedirect')) {
                        $state.go('appLayout.harriSH.dashboard');
                        defer.resolve();
                    }

                })
                .catch((err) => console.error(err));

            return defer.promise;
        };
}

angular
    .module("harriApp")
    .service("appLayoutViewService", AppLayoutViewService);
AppLayoutViewService.$inject = ['$state', 'hUser', 'brandServices', 'TeamScheduleService'];